export default "__VITE_ASSET__B3pVOgkG__"